import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the UsersListModal component.
 */
const useUsersListModalStyles = makeStyles()(() => ({
  usersListModal: {
    width: '25vw',
    height: '65vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  btns: {
    marginBottom: theme.margin.l,
  },
  btn: {
    'fontFamily': theme.fontFamily,
    'borderRadius': '20px',
    'backgroundColor': theme.background.paper,
    'color': theme.text.primary.light,
    '&.Mui-selected': {
      'color': theme.text.primary.dark,
      'backgroundColor': theme.primary.light,
      '&:hover': {
        color: theme.text.primary.dark,
        backgroundColor: theme.primary.dark,
      },
      '&:active': {
        backgroundColor: theme.primary.darker,
        boxShadow: theme.buttonShadow(theme.primary.darker),
        color: theme.text.primary.dark,
      },
    },
    '&: active': {
      backgroundColor: theme.primary.darker,
      boxShadow: theme.buttonShadow(theme.primary.darker),
      color: theme.text.primary.dark,
    },
    'padding': '6px 16px',
    'fontSize': '0.875rem',
  },
  userItem: {
    'padding': `${theme.padding.xs} ${theme.padding.s}`,
    'cursor': 'pointer',
    'fontFamily': theme.fontFamily,
    'fontSize': theme.fontSize.h5,
    'textTransform': 'none',
    'color': theme.text.primary.light,
    'display': 'flex',
    'justifyContent': 'flex-start',
    'alignItems': 'center',
    'width': '100%',
    'borderRadius': 0,
    'backgroundColor': theme.background.paper,
    'borderBottom': `1px solid ${colors.gray['300']}`,
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: colors.blue['100'],
    },
    '&:active': {
      backgroundColor: colors.blue['200'],
    },
  },
  scrollableModalContent: {
    overflowY: 'auto',
    width: '100%',
    height: '100%',
    border: `1px solid ${colors.black}`,
    borderRadius: theme.borderRadius.s,
    backgroundColor: theme.background.lighter,
  },
}));

export default useUsersListModalStyles;
